module.exports = __webpack_public_path__ + "static/media/soleus_left_tension.da532431.png";